import AuthCreators from '../LoginPage/reducer';
import NavCreators from '../../Redux/NavRedux';

export default {
  logout: AuthCreators.logout,
  changeTheme: NavCreators.navSetProp,
};
